import * as React from 'react'
import { EnrichedSettingsCategory } from '../../util/SettingsConfigurations';
import './SettingsBody.css'

export type ValueProps = {
  selectedCategory: EnrichedSettingsCategory
}

export type Props = ValueProps

export const SettingsBody = (props: Props) => (
  <div className="settings-body">
    {props.selectedCategory.content}
  </div>
)
